<script>
import BaseMixin from '../BaseMixin.vue';
import ValidationError from '@/components/UI/ValidationError.vue';

export default {
  components: {
    ValidationError
  },
  mixins: [BaseMixin],
  data() {
    return {
      months: window.CONSTANT.DATETIME.months,
      currentDate: new Date(),
      CPRa: '',
      CPRb: ''
    };
  },
  computed: {
    displayName() {
      return this.vueModel.Name.toLowerCase();
    },
    cprNumber() {
      return `${this.CPRa}${this.CPRb}`;
    }
  },
  watch: {
    cprNumber(val) {
      this.vueModel.AdditionalInformation.TakeoverInformation.TakeoverCPR = val;
    }
  },
  mounted() {
    // alert('MIXIN');
    // this.months = window.CONSTANT.DATETIME.months;
    $(document).scrollTop(0);
    $('#additional-information').addClass('active');
  },
  methods: {
    resetAll() {
      this.vueModel.AdditionalInformation.TakeoverInformation.SelectedTakeoverDate = null;
      this.vueModel.AdditionalInformation.TakeoverInformation.TakeoverNameType = -1;
      this.vueModel.AdditionalInformation.TakeoverInformation.TakeoverType = -1;
      this.vueModel.AdditionalInformation.TakeoverInformation.SelectedInsuranceCompany = null;
    },
    setModelsInitValueToNullForValidation() {},
    emptyArray(array) {
      while (array.length) {
        array.pop();
      }
    }
  }
};
</script>
